import { createTheme, Theme } from '@mui/material';

import { globalTheme } from '../../../../../../../shared/theme/theme';

export const statsTheme: Theme = createTheme(globalTheme, {
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          minHeight: '360px',
        },
      },
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '0 24px',
        },
      },
    },

    MuiTypography: {
      styleOverrides: {
        root: {
          '&.overall-rating': {
            fontSize: '64px',
            fontWeight: 300,
            lineHeight: '1em',
          },

          '&.total-ratings': {
            fontSize: '21px',
            fontWeight: 300,
            marginBottom: '48px',
          },

          '&.total-reviews': {
            fontSize: '48px',
            fontWeight: 300,
            margin: '0 21px 0 0',
            lineHeight: '1em',
          },

          '&.breakdown-title': {
            fontSize: '21px',
            fontWeight: 300,
            margin: '36px 24px 14px 0px',
          },
        },
      },
    },
  },
});
